const getOAuthServerMetadata = (authServerConfig) => {
    const baseUrl = authServerConfig.url;
    return {
        issuer: baseUrl,
        authorizationEndpoint: `${baseUrl}/oauth2/v2/auth`,
        tokenEndpoint: `${baseUrl}/api/token`,
        jwksUrl: `${baseUrl}/oidc/certs/v1`,
    };
};
export default getOAuthServerMetadata;
//# sourceMappingURL=getOAuthServerMetadata.js.map